import React from 'react';
import { Box, Button, Typography, Modal } from '@mui/material';

interface UnlockCardInfoModalProps {
  onClose: () => void;
  adminEmail?: string | null;
}

function UnlockCardInfoModal({ onClose, adminEmail }: UnlockCardInfoModalProps): JSX.Element {
  return (
    <Modal
      open={true}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(5px)',
            bgcolor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          pt: '35vh',
          height: '100vh',
          width: '100vw',
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            p: 2,
            width: '85%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              color: 'text.primary',
              p: 1,
            }}
          >
            Card Unlock
          </Typography>
          <Typography
            variant="large"
            sx={{
              textAlign: 'center',
              color: '#000',
              fontWeight: 300,
              lineHeight: 1.5,
              p: 1,
            }}
          >
            {adminEmail
              ? `To unlock card, please, contact your administrator at ${adminEmail}`
              : 'To unlock your card, please contact your administrator.'}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, mt: 1.5 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={onClose}
              sx={{
                py: 2,
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '1.5rem',
                bgcolor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                },
              }}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default UnlockCardInfoModal;
